module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/vi/6-70ad7353bd467b2ff0feead068d9232b.jpg";